// @flow

import React, { Component } from 'react';
import Alert from 'react-s-alert';

import CircularProgress from 'material-ui/CircularProgress';

import App from './App.jsx';
import Toolbar from './Toolbar.jsx';
import DialogSensorCultivoUPL from './DialogSensorCultivoUPL.jsx';

import './css/DialogSensorUPL.css';

import { fetch_shp } from './fetch_things.js';
import { T_Sen } from './types.js';
import { T_Info } from './DialogSensor.jsx';

type T_Modelo = {
  id_modelo: number,
  modelo: string,
  modelo_alt: string,
  descripcion: string,
  riesgos: Array<string>
};

type T_Enfermedad = {
  id_enfermedad: number,
  enfermedad: string,
  enfermedad_alt: string,
  modelos: Array<number>,
  modelos_data: Array<T_Modelo>,
  descripcion: string,
};

type T_Cultivo = {
  id_cultivo: number,
  cultivo: string,
  cultivo_alt: string,
  enfermedades: Array<number>,
  enfermedades_data: Array<T_Enfermedad>,
  descripcion: string
};

type T_DialogSensorUPLProps = {
  app: App,
  data: Array<T_Info>,
  data_diaria: Array<object>,
  email: string,
  sen: T_Sen,
  toolbar: Toolbar
}

type T_DialogSensorUPLState = {
  cultivos: Array<T_Cultivo>,
  cultivos_culti: Array<string>,
  superficie: number,
  loading: boolean
}

export default class DialogSensorUPL extends Component<T_DialogSensorUPLProps, T_DialogSensorUPLState> {
  constructor(props: T_DialogSensorUPLProps) {
    super(props);

    this.state = {
      cultivos: [],
      cultivos_culti: [],
      superficie: 0,
      loading: true
    };
  }

  componentDidMount() {
    const cultivos_culti = [ (((this.props.sen.dir.split('/'))[3]).split('-')[0]).toLowerCase() ]

    this.setState({ cultivos_culti });
    
    this.set_cultivos_data(cultivos_culti,  cultivos => {
      this.setState({ cultivos, loading: false });
    });

    if (this.props.toolbar !== null) {
      const { culti } = this.props.toolbar.state;
  
      fetch_shp(this.props.app, culti, (response) => {
        if (typeof response === 'string') {
          Alert.error(response);
        }
  
        const superficie = response.dbfRecords.map(rec => rec.HECTAREAS).reduce((a, b) => a + b);
  
        this.setState({ superficie });
      });
    } else {
      console.log(this.props.toolbar);
    }
  }

  async set_cultivos_data(cultivos, next) {
    const
      { app } = this.props,
      url = `${app.remote}/get-cultivos-data/?session_id=${app.session()}&cultivos=${cultivos}`
    ;

    await fetch(url).then(resp => resp.json()).then(data => next(data));
  }

  render() {
    const
      { cultivos, cultivos_culti, superficie, loading } = this.state,
      { app, data, data_diaria, sen } = this.props
    ;

    if (loading) {
      return (
        <div className="UPL-container">
          <div style={{ position: 'relative', width: '100%', height: 'auto', padding: '10px', margin: 'auto auto' }}>
            <CircularProgress color={'#db5c26'} size={78} thickness={6} value={70} />
          </div>
        </div>
      );
    } else {
      if (cultivos.length > 0) {
        return (
          <div className="UPL-container">
            {cultivos.map((cultivo, c) => 
              <DialogSensorCultivoUPL
                key={c}
                app={app}
                cultivo={cultivo}
                cultivo_culti={cultivos_culti[0]}
                data={data}
                data_diaria={data_diaria.slice(data_diaria.length - 7, data_diaria.length)}
                sen={sen}
                superficie={superficie}
              />
            )}
          </div>
        );
      } else {
        return (
          <div className="UPL-container" style={{ textAlign: 'center' }}>
            <span
              style={{
                position: 'relative',
                display: 'block',
                margin: '36px auto',
                fontFamily: 'GillSans',
                fontWeight: '600',
                fontSize: '22px',
                color: '#333333'
              }}
            >No existe un modelo o enfermedad asociados al cultivo seleccionado.</span>
          </div>
        )
      } 
    }
  }
}


// WEBPACK FOOTER //
// ./src/DialogSensorUPL.jsx